import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import he from './locales/he.json';
import bg from './locales/bg.json';

const SUPPORTED_LANGUAGES = ['en', 'he', 'bg'];
const stored = localStorage.getItem('language');
const savedLanguage = SUPPORTED_LANGUAGES.includes(stored) ? stored : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he },
      bg: { translation: bg },
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (value instanceof Date) {
          if (format === 'shortDate')
            return value.toLocaleDateString(lng, { day: '2-digit', month: '2-digit', year: 'numeric' });
          if (format === 'longDate')
            return value.toLocaleDateString(lng, { weekday: 'short', month: 'short', day: 'numeric' });
          if (format === 'time')
            return value.toLocaleTimeString(lng, { hour: '2-digit', minute: '2-digit' });
        }
        return value;
      },
    },
  });

// Keep document direction in sync
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  localStorage.setItem('language', lng);
});

// Set initial direction
document.documentElement.dir = savedLanguage === 'he' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLanguage;

export default i18n;